import { defineXray } from "../src/xray/manifest.js";
import { SHELL_TOOL_NAMES } from "../src/mine/shell.js";
import { extractIacOps, describeMissing } from "../extractors/iac/index.js";
import { collect, build, groupBy, anchor, ignore } from "../extractors/iac/spec.js";

export default defineXray({
  id: "iac",
  label: "Infra",
  title: "Infrastructure an agent planned and whether it applied it — the size of each proposed change, how much it would have destroyed, and which plans were left unapplied",

  consumer: "someone reviewing infrastructure changes an agent proposed",
  decision: "whether a planned change was ever applied, and how large a blast radius the session was looking at when it decided",

  // MEASURED AS FORMATTING. a plan is legible as written, and its finding — planned but never applied — belongs beside the session that decided
  tab: false,
  tabReason: "a plan is legible as written, and its finding — planned but never applied — belongs beside the session that decided",
  // Trace-only, so this does not down-select a tab of its own — it is how the
  // LINEAGE window finds the prompts carrying this lens's work. Same matcher
  // its tab-bearing siblings use: every op here is read off a shell command.
  substrate: { label: "shell (infrastructure stacks)", match: (n) => SHELL_TOOL_NAMES.test(String(n).split("__").pop()) },

  feed: { domain: "iac" },
  extract: extractIacOps, collect, group: build, groupBy, anchor, ignore,
  // The stack path. "the working directory" is what the extractor says when the
  // command named no stack — an honest absence of an identity, not an identity,
  // so it does not become one here.
  lineage: {
    kind: "stack",
    // A stack PATH in the repo, which is exactly how a plan or a diff names it.
    citable: true,
    ref: (op) => (op.stack && op.stack !== "the working directory" ? op.stack : null),
    // A plan is a proposal; only an apply or a destroy changed the world.
    role: (op) => (op.kind === "apply" || op.kind === "destroy" ? "production" : "consultation"),
    text: (op) => op.output || "",
    label: (op) => `${op.kind} ${op.stack}`,
    intent: (op) => (op.counts ? `${op.counts.add} add · ${op.counts.change} change · ${op.counts.destroy} destroy` : null),
  },

  emptyNote: "No infra work in this window",
  explainMissing: describeMissing,
});
